import React from 'react';
import { Link } from 'react-router-dom';
import ImageWithBaseApi from '../../common/mediaRender/ImageWithBaseApi';
import './TopRatedProductWidget.css';

const getPhotoUrl = (product) => {
    const optionPhoto = product.product_option.find(option => option.url);
    return optionPhoto ? optionPhoto.url : product.photos[0]?.src;
};

const TopRatedProductWidget = ({ publicUrl, products }) => (
    <div className="widget ltn__top-rated-product-widget go-top">
        <h4 className="ltn__widget-title ltn__widget-title-border-2 mb-4">Productos Utilizados en el Proyecto</h4>
        <ul className="scroll-light" style={{ maxHeight: '220px', overflowY: 'auto' }}>
            {products?.slice(0, 3)?.map((productWrapper, index) => (
                <li key={index} className="m-0 p-0 pb-10 mb-20">
                    <div className="top-rated-product-item clearfix">
                        <div className="top-rated-product-img">
                            <Link to={"/product/product-details/" + productWrapper?.product_id}>
                                <ImageWithBaseApi src={getPhotoUrl(productWrapper.product)} alt="#" />
                            </Link>
                        </div>
                        <div className="top-rated-product-info">
                            <h6 className="truncate"><Link to={"/product/product-details/" + productWrapper?.product_id}>{productWrapper.product.title}</Link></h6>
                            <div className="product-price">
                                <span className="truncate-3-lines">
                                    {productWrapper.product.description || productWrapper.product.tags?.join(', ')}
                                </span>
                            </div>
                        </div>
                    </div>
                </li>
            ))}
            {products?.length > 3 && (
                <div className="more-products">
                    {products?.slice(3)?.map((productWrapper, index) => (
                        <li key={index + 3}>
                            <div className="top-rated-product-item clearfix">
                                <div className="top-rated-product-img">
                                    <Link to={"/product/product-details/" + productWrapper?.product_id}>
                                        <ImageWithBaseApi src={getPhotoUrl(productWrapper.product)} alt="#" />
                                    </Link>
                                </div>
                                <div className="top-rated-product-info">
                                    <h6 className="truncate"><Link to={"/product/product-details/" + productWrapper?.product_id}>{productWrapper.product.title}</Link></h6>
                                    <div className="product-price">
                                        <span className="truncate-3-lines">
                                            {productWrapper.product.description || productWrapper.product.tags?.join(', ')}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ))}
                </div>
            )}
        </ul>
    </div>
);

export default TopRatedProductWidget;